var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4175 19.469C70.8913 19.469 73.7031 22.5618 73.7031 26.3915V69.5566C73.7031 73.3752 70.8941 76.4805 67.4175 76.4805H10.4519C6.9865 76.4805 4.17188 73.3766 4.17188 69.5566V25.4056C4.17188 21.5758 6.98094 19.4648 10.4519 19.4648",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3914 11.125C26.5623 11.125 27.5121 12.168 27.5121 13.4613L41.4184 28.3535C41.4184 29.6412 40.4672 30.6869 39.2977 30.6869H6.28702C5.11889 30.6869 4.17188 29.6412 4.17188 28.3535V13.4613C4.17188 12.168 5.12028 11.125 6.28702 11.125H25.3914Z",
    fill: "#FFA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4452 31.9062C81.9162 31.9062 84.728 34.999 84.728 38.8288L75.0395 69.5616C73.9826 72.3136 70.8398 76.4855 67.3633 76.4855H10.4519C6.9865 76.4855 4.17188 73.3816 4.17188 69.5616L13.8631 38.8288C15.2969 36.156 18.0628 31.9062 21.5338 31.9062",
    fill: "#FFCA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.8019d5d83989cd63fb04638886af0e9f.svg";
export { ForwardRef as ReactComponent };